module.exports = __webpack_public_path__ + "img/nl_Beta Digitis - Gif.6a7ab8de.gif";